import { cn } from '@shared/lib/cn';

import { TABLE_SKELETON_BAR_CLASS, TABLE_SKELETON_ROW_CLASS } from './table.constant';
import { tableCellShapeClass } from './table.lib';
import type { TableColumn } from './table-cell.ui';

export interface TableSkeletonRowsProps {
  /** 칸 너비를 본문 줄과 맞춘다 */
  columns: readonly TableColumn[];
  /** 줄 수. 기본 3 */
  rows?: number;
}

/**
 * Table 의 status=init — 본문 자리에 막대 줄(칸마다 둥근 막대 12). 머리 줄은 표가 그대로 그린다.
 * 보조기기에서는 숨긴다(표의 `aria-busy` 가 알린다).
 */
export function TableSkeletonRows({ columns, rows = 3 }: TableSkeletonRowsProps) {
  return (
    <div aria-hidden="true" data-status="init" className="skeleton-pulse flex flex-col">
      {Array.from({ length: rows }, (_, row) => (
        <div key={row} className={TABLE_SKELETON_ROW_CLASS}>
          {columns.map((column, index) => (
            <div
              key={column.key}
              className={cn('flex', tableCellShapeClass(column), column.className)}
            >
              <span
                className={cn(
                  'h-3 max-w-full rounded-full bg-bg-pressed',
                  TABLE_SKELETON_BAR_CLASS[(row + index) % TABLE_SKELETON_BAR_CLASS.length],
                )}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
